const FavoriteIcon = ({
    fill = "currentColor",
    color = "#000000",
    strokeWidth = "0.6px",
    filled,
    size,
    height,
    width,
    label,
    className,
    ...props
}) => {
    return (
        <svg
            width={size || width || 25}
            height={size || height || 25}
            viewBox="0 0 32 28"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
            {...props}
        >
            <path
                d="M17.1917 2.68843L16.9066 2.97718C16.6499 3.23387 16.3474 3.52902 16 3.86362L15.6049 3.48043C15.2933 3.17793 15.0274 2.91393 14.8074 2.68843C14.0333 1.8905 13.1068 1.25613 12.0829 0.822927C11.059 0.389723 9.95857 0.166504 8.84681 0.166504C7.73505 0.166504 6.63461 0.389723 5.61072 0.822927C4.58683 1.25613 3.66034 1.8905 2.88618 2.68843C-0.375316 6.01962 -0.406468 11.4023 2.79453 14.771L16 27.6667L29.2055 14.7719C32.4056 11.4023 32.3753 6.01962 29.1139 2.68843C28.3397 1.8905 27.4132 1.25613 26.3893 0.822927C25.3655 0.389723 24.265 0.166504 23.1533 0.166504C22.0415 0.166504 20.9411 0.389723 19.9172 0.822927C18.8933 1.25613 17.9668 1.8905 17.1926 2.68843H17.1917ZM4.59488 12.6636C2.60663 10.3536 2.69644 6.81343 4.85153 4.61252C5.36961 4.07609 5.9904 3.64946 6.67689 3.35809C7.36338 3.06671 8.10152 2.91654 8.84728 2.91654C9.59305 2.91654 10.3312 3.06671 11.0177 3.35809C11.7042 3.64946 12.325 4.07609 12.843 4.61252L13.4929 5.26152C13.5558 5.32337 13.6187 5.3851 13.6818 5.44672L16 7.67963L18.1175 5.64098L18.6859 5.08548L19.157 4.61248C19.6751 4.07591 20.296 3.64916 20.9825 3.3577C21.6691 3.06624 22.4074 2.91603 23.1532 2.91603C23.8991 2.91603 24.6374 3.06624 25.3239 3.3577C26.0105 3.64916 26.6313 4.07591 27.1494 4.61248C29.3604 6.87113 29.3971 10.5406 27.2439 12.8441L16 23.8231L4.75619 12.8433L4.59488 12.6636Z"
                fill={fill} stroke={color} strokeWidth={strokeWidth} />
        </svg>


    );
};

const FavoriteFillIcon = ({
    fill = "#F55555",
    color = "#F55555",
    strokeWidth = "0.6px",
    filled,
    size,
    height,
    width,
    label,
    className,
    ...props
}) => {
    return (
        <svg
            width={size || width || 25}
            height={size || height || 25}
            viewBox="0 0 32 28"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
            {...props}
        >
            <path
                d="M14.8083 2.68843L15.0934 2.97718C15.3501 3.23384 15.6526 3.52901 16 3.86359L16.3951 3.48043C16.7067 3.17793 16.9726 2.91393 17.1926 2.68843C17.9667 1.8905 18.8932 1.25613 19.9171 0.822926C20.941 0.389722 22.0414 0.166504 23.1532 0.166504C24.265 0.166504 25.3654 0.389722 26.3893 0.822926C27.4132 1.25613 28.3397 1.8905 29.1138 2.68843C32.3753 6.01959 32.4065 11.4023 29.2055 14.771L16 27.6667L2.7945 14.7719C-0.405585 11.4023 -0.375335 6.01959 2.88617 2.68843C3.66032 1.8905 4.58681 1.25613 5.6107 0.822926C6.63459 0.389722 7.73503 0.166504 8.84679 0.166504C9.95855 0.166504 11.059 0.389722 12.0829 0.822926C13.1068 1.25613 14.0333 1.8905 14.8074 2.68843H14.8083Z"
                fill={fill} stroke={color} strokeWidth={strokeWidth} />
        </svg>


    );
};

export { FavoriteIcon, FavoriteFillIcon }